import { useEffect, useState } from 'react'
import { Dimensions } from 'types'
import { MAX_PREVIEW_HEIGHT, MAX_PREVIEW_WIDTH } from '../constants'

export function usePreviewDimensions(sourceWidth: number, sourceHeight: number) {
    const [state, setState] = useState<Dimensions>({ height: MAX_PREVIEW_HEIGHT, width: MAX_PREVIEW_WIDTH })

    useEffect(() => {
        const aspectRatio = sourceWidth / sourceHeight
        let width = MAX_PREVIEW_WIDTH
        let height = Math.round(width / aspectRatio)

        if (height > MAX_PREVIEW_HEIGHT) {
            height = MAX_PREVIEW_HEIGHT
            width = Math.round(height * aspectRatio)
        }

        setState({
            height,
            width,
        })
    }, [sourceHeight, sourceWidth])

    return state
}
